import React from 'react';

import Page from 'components/Page/Dashboard';
import BetFilter from 'components/Bet/BetFilter';

const Filter = () => (
  <Page>
    <BetFilter mode="view" />
  </Page>
);

export default Filter;
